import React from "react";

import classes from "./ToolBar.module.css";

const ToolBar = (props) => {
  return (
    <div className={classes.BtnGroup}>
      <button
        className={props.activityMode === "post" ? classes.Chosed : classes.Btn}
        type="button"
        onClick={(event) => {
          props.activityModeHandler("post");
        }}
      >
        Post
      </button>
      <button
        className={
          props.activityMode === "paymentHistory" ? classes.Chosed : classes.Btn
        }
        type="button"
        onClick={(event) => {
          props.activityModeHandler("paymentHistory");
        }}
      >
        Payment History
      </button>
      <button
        className={
          props.activityMode === "invoices" ? classes.Chosed : classes.Btn
        }
        type="button"
        onClick={(event) => {
          props.activityModeHandler("invoices");
        }}
      >
        Invoices
      </button>
    </div>
  );
};

export default ToolBar;
